export const utilsMixin = {
  methods: {
    showSuccessSnackbar(message) {
      this.snackbarMessage = message;
      this.snackbarColor = 'green';
      this.showSnackbar = true;
    },

    showWarningSnackbar(message) {
      this.snackbarMessage = message;
      this.snackbarColor = 'warning';
      this.showSnackbar = true;
    },

    showErrorSnackbar(message) {
      this.snackbarMessage = message;
      this.snackbarColor = 'red';
      this.showSnackbar = true;
    },
        
    _getToken() {
      const token = JSON.parse(localStorage.getItem('accessToken'));
      if (!token) throw new Error('No se encontró token de autenticación');
      return token;
    },

    _getUserId() {
      const userId = this.$route.params.pgId;
      if (!userId) throw new Error('ID de usuario no encontrado');
      return userId;
    },

    parseAddress(address) {
      const result = { region: '', commune: '', street: '', number: '', extra: '' };
      
      if (address) {
        const parts = address.split(',').map(s => s.trim());
        if (parts.length >= 3) {
          const streetParts = parts[0].split(' ');
          result.street = streetParts.slice(0, -1).join(' ');
          result.number = streetParts.pop() || '';
          result.commune = parts[1];
          result.region = parts[2];
        } else if (parts.length === 1) {
          result.street = parts[0];
        }
      }
      
      return result;
    },

    parseBirthdate(birthdate) {
      if (!birthdate || birthdate === '-') return null;
      
      const dateParts = birthdate.split('/');
      if (dateParts.length !== 3) {
        return null;
      }

      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      let year = parseInt(dateParts[2], 10);

      if (year < 100) year += (year < 70 ? 2000 : 1900);
      
      const parsedDate = new Date(year, month, day);
      
      if (isNaN(parsedDate.getTime())) {
        return null;
      }

      return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    },

    splitName(fullName = '') {
      const firstSpaceIndex = fullName.indexOf(' ');
      return firstSpaceIndex !== -1
        ? [fullName.substring(0, firstSpaceIndex).trim(), fullName.substring(firstSpaceIndex + 1).trim()]
        : [fullName.trim(), ''];
    },

    disabled() {
      return false;
    }
  }
};